module.exports = __webpack_public_path__ + "static/media/male.a257aae0.gif";